/**
 * Typography tokens for the Travo theme.
 * Noto Sans TC follows each Latin face so Traditional Chinese falls back per glyph.
 */

export const fonts = {
  heading: { value: `'Shrikhand', 'Noto Sans TC', serif` },
  body: { value: `'DM Sans', 'Noto Sans TC', system-ui, sans-serif` },
  mono: { value: `'DM Mono', 'Noto Sans TC', ui-monospace, monospace` }
} as const;
